<template>
  <b-modal
    id="custom-field-delete-modal"
    ref="customFieldDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete this field?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CustomFieldDeleteModal',
  props: {
    fieldp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      customFieldDeleted: 'contact/customFieldDeleted',
      apiError: 'contact/apiError',
    }),
  },
  watch: {
    customFieldDeleted(deleted) {
      if (deleted) {
        this.$emit('deleted', deleted);
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteCustomField: 'contact/deleteCustomField',
    }),
    commitDelete() {
      this.deleting = true;
      this.deleteCustomField({
        merchant_id: this.$route.params.merchant_id,
        field_id: this.fieldp.id,
      });
    },
    show() {
      this.$refs.customFieldDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.customFieldDeleteModal.hide();
    },
  },
};
</script>
